import React, { useState } from "react";
import { Grid } from "@mui/material";
import { AuthContext } from "../../components/auth/AuthContext";
import Filters from "../../components/filters/index.js";
import Loader from "../../components/loader/index.jsx";
import { useThemeMode } from "../../components/theme/index.jsx";
import AgentAnalytics from "./home-agent-analytics.jsx";
import ComplianceCard from "./home-compliance-card.js";
import PlaylistsCard from "./home-playlist-card.js";
import SentimentChart from "./home-sentiment-chart";
import TopAlertsCard from "./home-top-alerts-card.js";
import TopQuestionsCard from "./home-top-questions.js";
import TopTrackersCard from "./home-top-trackers-card.js";
import TopicSentimentChart from "./home-topic-sentiment-chart";
import VocalysdScore from "./home-vocalysd-score.js";
import TalkRatioCard from "./homr-talk-ratio-card.js";
import { getInsightDataAPI } from "../../services/analytics.js";
import { CompanyInsightModel } from "../../models/company.js";
import { INSIGHT_PAGE } from "../../helpers/constant.js";

function Home() {
    const { currentNonAdminGroup, isAuthenticated } = React.useContext(AuthContext);
    const { colours, themeMode, FONT } = useThemeMode();
    const [analytics, setAnalytics] = useState(new CompanyInsightModel());
    const [spinner, setSpinner] = React.useState(false);

    async function getCampaignData() {
        try {
            setSpinner(true);
            console.log("currentNonAdminGroup: ", currentNonAdminGroup);
            if (!currentNonAdminGroup) {
                throw (new Error("currentNonAdminGroup is not set. Please login or reload the page."));
            }

            const { data } = await getInsightDataAPI({ id: currentNonAdminGroup, type: INSIGHT_PAGE.COMPANY });
            console.log("Company Data:", data);
            setAnalytics(Object.assign(analytics, data));
            setSpinner(false);
        } catch (error) {
            setSpinner(false);
            console.log("get:ERROR = ", error)
        }
    }

    React.useEffect(() => {
        if (isAuthenticated) {
            getCampaignData();
        }
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [currentNonAdminGroup, isAuthenticated]);

    return (
        <React.Fragment>
            {spinner && <Loader />}
            <Grid
                className="vocalysed-home-upadted analytics"
                container
                spacing={0}
                direction="row"
                flexGrow={1}
                padding={3}
                gap={3}
                overflow="auto"
            >
                <Grid item xs={12} lg sx={{ minWidth: "1px" }} display="flex" flexDirection="column" gap={3}>
                    <SentimentChart
                        sentimentData={analytics.sentiment}
                    />
                    <TopicSentimentChart topicdata={analytics.topic_based_sentiment} colours={colours} />
                    <AgentAnalytics
                        loading={spinner}
                        colours={colours}
                        listOfAgents={analytics.agent_analytics}
                        themeMode={themeMode}
                    />
                </Grid>
                <Grid item xs={12} lg sx={{ minWidth: "1px" }} display="flex" flexDirection="column" gap={3}>
                    <VocalysdScore allscore={analytics.vocalys_score} colours={colours} FONT={FONT} />
                    <Grid
                        container
                        flexWrap={{ sm: "nowrap" }}
                        justifyContent="space-between"
                        gap={3}
                    >
                        <ComplianceCard data={analytics.campliance_data} colours={colours} FONT={FONT} />
                        <TopTrackersCard data={analytics.top_insights} />
                    </Grid>
                    <PlaylistsCard play_list={analytics.play_list} colours={colours} FONT={FONT} />
                    <Grid
                        container
                        flexWrap={{ sm: "nowrap" }}
                        justifyContent="space-between"
                        gap={3}
                    >
                        <TalkRatioCard data={analytics.talk_ratio} colours={colours} FONT={FONT} />
                        <TopAlertsCard data={analytics.alerthits} colours={colours} />
                    </Grid>
                    <TopQuestionsCard
                        data={analytics.questionhits}
                        colours={colours}
                        themeMode={themeMode}
                    />
                    {/* {
                        <div
                        style={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            height: "100vh",
                            width: "300px",
                            transform: isDatePickerVisible
                            ? "translateX(0)"
                            : "translateX(100%)",
                            transition: "transform 0.3s ease-in-out",
                            boxShadow: isDatePickerVisible
                            ? "0px 0px 10px rgba(0,0,0,0.3)"
                            : "none",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                        }}
                        >
                        <DatePickerComponent />
                        </div>
                    } */}
                </Grid>
                <Filters />
            </Grid>
        </React.Fragment>
    );
}

export default Home;